// Reduced motion: players who ask their system for less movement get the cards without the flip
// and the board reveal without the long shuffle.
export function prefersReducedMotion() {
  try {
    return !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}
